import { Component, Input } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
  selector: 'app-badge-list',
  templateUrl: './badge-list.component.html',
  styleUrls: ['./badge-list.component.scss'],
  standalone: false,
})
export class BadgeListComponent implements ICellRendererAngularComp {
  @Input('InputBadges') inputBadges: string[] = [];
  badges: string[];

  constructor() {}

  agInit(params: ICellRendererParams): void {
    if (params) {
      this.inputBadges = params.value ?? [];
    }
  }
  refresh(params: ICellRendererParams): boolean {
    return false;
  }

  ngOnInit() {
    if (this.inputBadges) {
      this.badges = this.inputBadges;
    }
  }
}
